module.exports = __webpack_public_path__ + "static/media/intro-image.b0e100ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Welcome/intro-image.jpg
// module id = 692
// module chunks = 0